<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_device_alarm"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
        :query="params"
        @on-add="showFormModalDialog"
        @on-batch-del="onBatchDeleteDone"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
import { getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'
import { getLabelByCode } from '@/utils/util'
export default {
  name: 'DeviceAlarm',
  components: {
    TableWrapper
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/agent/alarm',
      modalForm: false,
      entityId: 0,
      modCount: 0,
      garages: this.loadGarages(),
      selection: [],
      timeout: 30000
    }
  },
  computed: {
    alarmAckPermitted() { return isAdmin() || hasPermission('PEM_TEMP_OPS_ALARM_ACK') },
    params() { return { } },
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '告警时间', width: '200px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择告警日期...', type: 'dateranger', hidden: false },
          { label: '告警车库', placeholder: '请选择告警车库...', name: 'parkingId', width: '200px', type: 'select', options: this.garages },
          { label: '告警状态', placeholder: '请选择告警状态...', name: 'status', width: '150px', type: 'select', options: this.$config.alarmStatus }
        ]
      }
    },
    columns() {
      const _this = this
      return [
        { title: '序号', type: 'index', width: 70, align: 'center' },
        { title: '车库', align: 'left', key: 'parkingName', resizable: true, sortable: true, ellipsis: true, tooltip: true },
        { title: '终端', align: 'left', key: 'agentLabel', resizable: true, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.agentLabel || '---')
          }
        },
        { title: '告警设备', align: 'center', key: 'deviceType', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {},
              getLabelByCode(params.row.deviceType, this.$config.deviceTypes) +
              ' (' +
              getLabelByCode(params.row.deviceInOut, this.$config.deviceEntryTypes) +
              ')')
          }
        },
        { title: '告警级别', align: 'center', key: 'alarmSeverity', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, getLabelByCode(params.row.alarmSeverity, this.$config.alarmSeverities))
          }
        },
        { title: '告警事件', align: 'center', key: 'alarmEvent', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.alarmEvent || '---')
          }
        },
        { title: '告警状态', align: 'center', key: 'alarmStatus', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: {
                color: params.row.alarmStatus === 0 ? 'red' : 'green'
              }
            }, getLabelByCode(params.row.alarmStatus, this.$config.alarmStatus))
          }
        },
        { title: '告警时间', align: 'center', key: 'alarmTime', sortable: true, ellipsis: true, width: 160, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.alarmTime || '---')
          }
        },
        { title: '确认时间', align: 'center', key: 'ackTime', sortable: true, ellipsis: true, width: 160, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.ackTime || '---')
          }
        },
        { title: '操作人员', align: 'center', key: 'operator', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.operator || '---')
          }
        },
        { title: '操作', align: 'center', width: 150, disabled: true, key: '_actions',
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.alarmAckPermitted && params.row.alarmStatus === 0),
                on: {
                  click: () => {
                    if (params.row.id && _this.alarmAckPermitted && params.row.alarmStatus === 0) {
                      this.showChangeAlarmStatusModalDialog(params.row.id, params.row)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-check': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: params.row.alarmStatus === 0 ? '确认告警' : '告警信息已确认'
                  }
                }, '确认告警')
              ])
            ])
          }
        }]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showTemporaryVehicle(id, parkingId, parkingName) {
      this.entityId = id
      this.modalForm = true
    },
    showChangeAlarmStatusModalDialog: function(id, rowData, cancel = false) {
      const _this = this
      this.$Modal.confirm({
        title: (cancel ? '取消' : '确认') + '告警信息么？',
        loading: true,
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/agent/alarm/' + id + '/action/' + (cancel ? 'cancel' : 'acknowledge'),
            method: 'PUT'
          }).then(res => {
            this.$Notice.success({
              title: '状态更新成功',
              desc: '车辆告警状态更新成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '状态更新失败',
              desc: '车辆告警状态更新失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    }
  }
}
</script>
